export function changeStyle(primary, secondary) {

    const style = document.getElementById('backend-css');

    primary = primary || '#2a63af';
    secondary = secondary || '#004f75';

    const primary_rgb = hextToRgb(primary);
    const secondary_rgb = hextToRgb(secondary);

    style.innerHTML = `:root {
        --color-primary: ${primary};
        --color-secondary: ${secondary};
        --color-primary-rgb: ${primary_rgb};
        --color-secondary-rgb: ${secondary_rgb};
    }`
}

export function hextToRgb(hex) {

    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    return [r, g, b];
}

export function rgbToHex(r, g, b) {

    const hex = [r, g, b].map(number => number.toString(16).padStart(2, '0').toUpperCase() ).join('');

    return '#' + hex;
}


export const colors = [{
        name: "Vermelho",
        hex: "#EF5350",
    },
    {
        name: "Rosa",
        hex: "#EC407A"
    },
    {
        name: "Roxo",
        hex: "#AB47BC"
    },
    {
        name: "Lilás",
        hex: "#7E57C2"
    },
    {
        name: "Índigo",
        hex: "#5C6BC0"
    },
    {
        name: "Azul",
        hex: "#42A5F5"
    },
    {
        name: "Azul Claro",
        hex: "#29B6F6"
    },
    {
        name: "Ciano",
        hex: "#26C6DA"
    },
    {
        name: "Verde Azulado",
        hex: "#26A69A"
    },
    {
        name: "Verde",
        hex: "#66BB6A"
    },
    {
        name: "Verde Claro",
        hex: "#9CCC65"
    },
    {
        name: "Amarelo Limão",
        hex: "#D4E157"
    },
    {
        name: "Amarelo",
        hex: "#FFEE58"
    },
    {
        name: "Âmbar",
        hex: "#FFCA28"
    },
    {
        name: "Laranja",
        hex: "#FFA726"
    },
    {
        name: "Laranja Escuro",
        hex: "#FF7043"
    },
    {
        name: "Marrom",
        hex: "#8D6E63"
    },
    {
        name: "Cinza",
        hex: "#BDBDBD"
    }
];



// WEBPACK FOOTER //
// ./src/helpers/style.js